import { DetailRow } from "../Profile";

export default function CabTab({ cab }) {
    return (
        <div className="p-details" role="tabpanel">
            <DetailRow label="Cab ID" value={cab.cab_id} mono />
            <DetailRow label="Model" value={cab.cab_model} mono />
            <DetailRow label="Number" value={cab.cab_number} mono />
            <DetailRow label="Vehicle type" value={cab.medium_type} />
            <DetailRow
                label="Seat capacity"
                value={cab.seat_capacity != null ? String(cab.seat_capacity) : null}
            />
            <DetailRow label="Region" value={cab.region_id} last />
        </div>
    );
}